import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Home from './views/Home';
import About from './views/About';
import Contact from './views/Contact';
import Horoscopo from './views/Horoscopo';
import Tirada from './views/Tirada';
import Frase from './views/Frase';
import CompatibilidadWrapper from './views/CompatibilidadWrapper';
import StarsBackground from "./components/StarsBackground/StarsBackground";

const App = () => {
  const [, setLabel] = useState("horoscopo");

  return (
    <Router>
      <div className="AppWrapper">
        <StarsBackground />
        <Navbar setLabel={setLabel} />
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/horoscopo/:signo?" element={<Horoscopo/>} />
          <Route path="/frase/:signo?" element={<Frase />} />
          <Route path="/tirada" element={<Tirada />} />
          <Route path="/compatibilidad/:signo1?/:signo2?" element={<CompatibilidadWrapper />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;